<template>
  <div>
    <mia-dealer-feature-notice
      class="mb-6"
      :feature="{
        cars_advanced: !authDealer.item_is_allowed_cars_advanced,
        vap: !authDealer.item_is_allowed_vap,
        orderconfirmation: !authDealer.item_is_allowed_orderconfirmation,
      }"
    />

    <mia-form @submit="save">
      <mia-form-section
        title="Texte"
        description="Hier legen Sie Standardtexte, z.B. für die Erstellung von Kundenangeboten oder Auftragsbestätigungen, fest."
      >
        <mia-notice
          title="Verfügbare Platzhalter"
          permanent
        >
          <p>Sie können in den Texten die nachfolgenden Platzhalter verwenden.</p>

          <table>
            <thead>
              <tr>
                <th class="px-2 py-1">
                  Platzhalter
                </th>
                <th class="px-2 py-1">
                  Beschreibung
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="px-2 py-1 font-bold">
                  {Anrede}
                </td>
                <td class="px-2 py-1">
                  Individuelle Kundenanrede (Sehr geehrte/r Frau/Herr/Firma)
                </td>
              </tr>
              <tr>
                <td class="px-2 py-1 font-bold">
                  {VerkäuferName}
                </td>
                <td class="px-2 py-1">
                  Name des angemeldeten Verkäufers
                </td>
              </tr>
              <tr>
                <td class="px-2 py-1 font-bold">
                  {VerkäuferTelefon}
                </td>
                <td class="px-2 py-1">
                  Telefon des angemeldeten Verkäufers
                </td>
              </tr>
              <tr>
                <td class="px-2 py-1 font-bold">
                  {VerkäuferEmail}
                </td>
                <td class="px-2 py-1">
                  E-Mail des angemeldeten Verkäufers
                </td>
              </tr>
            </tbody>
          </table>
        </mia-notice>

        <mia-form-section-grid>
          <div
            v-if="authDealer.item_is_allowed_cars_advanced"
            class="col-span-2"
          >
            <mia-feature-textarea
              v-model="form.item_offer_defaulttext"
              label="Standardtext für Angebote"
              class="mt-4"
            />
          </div>

          <div
            v-if="authDealer.item_is_allowed_vap"
            class="col-span-2"
          >
            <mia-feature-textarea
              v-model="form.item_offer_teaser"
              label="Angebotstext"
              class="mt-4"
            />
          </div>

          <div
            v-if="authDealer.item_is_allowed_orderconfirmation"
            class="col-span-2"
          >
            <mia-feature-textarea
              v-model="form.item_confirmation_defaulttext"
              label="Standardtext für Auftragsbestätigungen"
              class="mt-4"
            />
          </div>

          <div
            v-if="authDealer.item_is_allowed_orderconfirmation_wolfsburg"
            class="col-span-2"
          >
            <mia-feature-textarea
              v-model="form.item_confirmation_defaulttext_wolfsburg"
              label="Standardtext für Auftragsbestätigungen Wolfsburg"
              class="mt-4"
            />
          </div>

          <div
            v-if="authDealer.item_is_allowed_vap && sourcerCount > 0"
            class="col-span-2"
          >
            <mia-feature-textarea
              v-model="form.item_mediator_teaser"
              label="Text für Vermittlervertrag"
              class="mt-4"
            />
          </div>

          <div
            v-if="authDealer.item_is_allowed_vap"
            class="col-span-2"
          >
            <mia-feature-textarea
              v-model="form.item_offer_additional_special_agreements"
              label="Gewerbliche Kunden: Zusätzliche besondere Vereinbarungen"
              class="mt-4"
            >
              <template #label="{ htmlFor, label }">
                <label
                  class="flex flex-col mb-1"
                  :for="htmlFor"
                >
                  <span class="tracking-wider text-gray-800">{{ label }}</span>
                  <span class="text-sm italic text-gray-600">Dieser Text wird automatisch den "Besonderen Vereinbarungen" in generierten Angeboten und Verträgen angefügt.</span>
                </label>
              </template>
            </mia-feature-textarea>
          </div>

          <div
            v-if="authDealer.item_is_allowed_vap"
            class="col-span-2"
          >
            <mia-feature-textarea
              v-model="form.item_contract_additional_text"
              label="Zusatztext für Verträge"
              class="mt-4"
            />
          </div>
        </mia-form-section-grid>
      </mia-form-section>

      <template #actions>
        <div class="flex items-center justify-between w-full">
          <mia-section-progress
            group="settingsBasics"
            page="texts"
            section="generalData"
          />

          <mia-submit-button
            :disabled="$wait.any"
            :is-loading="$wait.is('updating texts general data')"
          />
        </div>
      </template>
    </mia-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { updateTextsGeneralData } from '@/api/settings'
import DealerFeatureNotice from '@/components/cars/edit/DealerFeatureNotice.vue'
import FeatureTextarea from '@/components/cars/edit/FeatureTextarea.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import SectionProgress from '@/components/cars/edit/SectionProgress.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'MiaSettingsBasicsTextsGeneralForm',

  components: {
    'mia-dealer-feature-notice': DealerFeatureNotice,
    'mia-feature-textarea': FeatureTextarea,
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-notice': Notice,
    'mia-section-progress': SectionProgress,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      form: {
        item_offer_defaulttext: '',
        item_offer_teaser: '',
        item_confirmation_defaulttext: '',
        item_confirmation_defaulttext_wolfsburg: '',
        item_mediator_teaser: '',
        item_offer_additional_special_agreements: '',
        item_contract_additional_text: ''
      }
    }
  },

  computed: {
    ...mapGetters('settings', [
      'settings',
      'sourcerCount'
    ])
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(settings) {
        this.$set(this.form, 'item_offer_defaulttext', settings.item_offer_defaulttext)
        this.$set(this.form, 'item_offer_teaser', settings.item_offer_teaser)
        this.$set(this.form, 'item_confirmation_defaulttext', settings.item_confirmation_defaulttext)
        this.$set(this.form, 'item_mediator_teaser', settings.item_mediator_teaser)
        this.$set(this.form, 'item_offer_additional_special_agreements', settings.item_offer_additional_special_agreements || '')
        this.$set(this.form, 'item_contract_additional_text', settings.item_contract_additional_text || '')

        if (this.authDealer.item_confirmation_defaulttext_wolfsburg) {
          this.$set(this.form, 'item_confirmation_defaulttext_wolfsburg', settings.item_confirmation_defaulttext_wolfsburg)
        }
      }
    }
  },

  methods: {
    async save() {
      this.resetErrors()
      this.$wait.start('updating texts general data')

      const payload = {
        item_offer_defaulttext: this.form.item_offer_defaulttext,
        item_offer_teaser: this.form.item_offer_teaser,
        item_confirmation_defaulttext: this.form.item_confirmation_defaulttext,
        item_mediator_teaser: this.form.item_mediator_teaser,
        item_offer_additional_special_agreements: this.form.item_offer_additional_special_agreements,
        item_contract_additional_text: this.form.item_contract_additional_text
      }

      if (this.authDealer.item_is_allowed_orderconfirmation_wolfsburg) {
        payload.item_confirmation_defaulttext_wolfsburg = this.form.item_confirmation_defaulttext_wolfsburg
      }

      const [error] = await updateTextsGeneralData(payload)

      this.$wait.end('updating texts general data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })

        this.handleBackendValidationErrors(error)
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich gespeichert.']
      })

      await this.$store.dispatch('settings/loadSettings')
    }
  }
}
</script>
